import r from "react-dom";
const o = ({
  container: t,
  children: e
}) => t ? r.createPortal(e, t) : null;
export {
  o as InsertedContent
};
//# sourceMappingURL=InternalContent.es.js.map
